<template>
  <div class="field-renderer">
    <label :for="field.name">{{ field.label }}</label>

    <!-- Check if the field is an array -->
    <div v-if="field.is_array" v-auto-animate>
      <!-- Loop over the localValue (which will be an array) and display input fields for each value -->
      <div v-for="(value, index) in localValue" :key="index" class="mb-3">
        <div class="d-flex justify-content-between" style="gap: 15px">
          <Field
            v-model="localValue[index]"
            :field="field"
          />
          <button @click="removeArrayValue(index)" type="button" class="btn btn-danger">
            <i class="fa fa-trash"></i>
          </button>
        </div>

        <!-- Display validation errors -->
        <ul v-if="v$.formData.$dirty && v$.formData[field.id]?.$each?.$response?.$data?.[index]?.$error" class="error-list">
          {{ v$.formData[field.id].$each.$response.$errors?.find(e => e.$model === value)?.$message }}
        </ul>
      </div>
      <!-- Button to add a new input field to the array -->
      <div class="d-flex justify-content-end">
        <button @click="addArrayValue" type="button" class="btn btn-primary">
          <i class="fa fa-plus"></i>
        </button>
      </div>
    </div>

    <!-- For non-array fields, use the native component as before -->
    <template v-else>
      <Field
        v-model="localValue"
        :field="field"
      />
  
      <!-- Display validation errors -->
      <ul v-if="v$?.formData?.[field.id]?.$error" class="error-list">
        <li v-for="error in v$?.formData?.[field.id]?.$errors" :key="error.$uid" class="error-item">
          {{ error.$message }}
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import Field from './Field.vue';

export default {
  components: { Field },
  props: {
    field: {
      type: Object,
      required: true,
    },
    modelValue: [String, Number, Boolean, Array, Object],
    v$: Object,
  },
  emits: ["update:modelValue"],

  computed: {
    // Manage the value (array or single value)
    localValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },

  methods: {
    // Add a new value to the array
    addArrayValue() {
      const newValue = this.field.type === "checkbox" ? false : ""; // Default value based on the type
      this.localValue = [...this.localValue, newValue];
    },

    // Remove a value from the array
    removeArrayValue(index) {
      const updatedArray = this.localValue.filter((_, i) => i !== index);
      this.localValue = updatedArray;
    },
  },
};
</script>

<style>
.error-list {
  margin: 0;
  padding: 0;
  list-style: none;
  color: red;
  font-size: 0.9em;
}

.error-item {
  margin-bottom: 0.2em;
}

.field-renderer {
  margin-top: 15px;
}
</style>
